import type { CurrencyCodes } from '@onevesthq/ov-enums';
import { getCurrencyFlag } from '@utils/currency';
import { Box } from 'hephaestus/web';

type IBaseCurrencyFlag = {
  baseCurrency: CurrencyCodes;
  height?: number;
  width?: number;
  borderRadius?: number;
};

export const CurrencyFlag: React.FC<IBaseCurrencyFlag> = ({
  baseCurrency,
  height = 20,
  width = 20,
  borderRadius = 10,
}) => (
  <Box
    sx={{
      height: height,
      width: width,
      borderRadius: borderRadius,
      overflow: 'hidden',
    }}
  >
    <img
      alt={baseCurrency}
      src={getCurrencyFlag(baseCurrency)}
      style={{ objectFit: 'cover', height: '100%' }}
    />
  </Box>
);
